import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { UriApi } from '../helpers/UriApi';
import { SHOW_ERROR } from '../helpers/http-context.tokens';
import { Constants } from '../helpers/constants';

@Injectable({
  providedIn: 'root',
})
export class KsNetService {
  body = {
    request: {
      jsonParams: {},
      functionCode: 109,
      data: "",
      dataList: "",
      menuCd: '',
    }
  };
  constructor(private http: HttpClient, private auth: AuthenticationService
  ) { }

  payment(param: any, signature: any) {
    const url = signature?.agentUrl || 'http://127.0.0.1:51234/api/default';
    const headers = new HttpHeaders({
      'X-Signature': signature?.signature || signature?.Signature,
      'X-Timestamp': signature?.timestamp || signature?.Timestamp,
      'X-Nonce': signature?.nonce || signature?.Nonce
    });

    return this.http.post(
      url,
      param,
      {
        headers,
        context: new HttpContext().set(SHOW_ERROR, false)
      }
    );
  }

  peymentSuccess(vanResponse: any, pendingId: number) {
    const param = {
      pendingId: pendingId,
      vanResponse: vanResponse
    }
    return this.http.post(UriApi.api_ServicePos_Paysuccess, param)
  }

  peymentSuccessNoLoading(vanResponse: any, pendingId: number): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      const param = {
        pendingId: pendingId,
        vanResponse: vanResponse
      }
      var language = localStorage.getItem(Constants.Language);
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '');
      header.append('Language', language || 'ko');
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_ServicePos_Paysuccess, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(param),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  peymentChargeSuccessNoLoading(vanResponse: any, pendingId: number): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      const param = {
        pendingId: pendingId,
        vanResponse: vanResponse
      }
      var language = localStorage.getItem(Constants.Language);
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      header.append('Language', language || 'ko');
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_SaleCharge_Paysuccess, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(param),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  paymentChargeSuccess(vanResponse: any, pendingId: number) {
    const param = {
      pendingId: pendingId,
      vanResponse: vanResponse
    }
    return this.http.post(UriApi.api_SaleCharge_Paysuccess, param)
  }

  print(param: any, signature: any) {
    const url = signature?.agentUrl || 'http://127.0.0.1:51234/api/default';
    const headers = new HttpHeaders({
      'X-Signature': signature?.signature || signature?.Signature,
      'X-Timestamp': signature?.timestamp || signature?.Timestamp,
      'X-Nonce': signature?.nonce || signature?.Nonce
    });

    return this.http.post(
      url,
      param,
      {
        headers,
        context: new HttpContext().set(SHOW_ERROR, false)
      }
    );
  }

  cancel(param: any, signature: any) {
    const url = signature?.agentUrl || 'http://127.0.0.1:51234/api/default';
    const headers = new HttpHeaders({
      'X-Signature': signature?.signature || signature?.Signature,
      'X-Timestamp': signature?.timestamp || signature?.Timestamp,
      'X-Nonce': signature?.nonce || signature?.Nonce
    });

    return this.http.post(
      url,
      param,
      {
        headers,
        context: new HttpContext().set(SHOW_ERROR, false)
      }
    );
  }

  cancelSaleSuccess(vanResponse: any, pendingId: number) {
    const param = {
      pendingId: pendingId,
      vanResponse: vanResponse
    }
    return this.http.post(UriApi.api_ServicePos_CancelSaleCardSuccess, param)
  }

  cancelSaleSuccessNoLoading(vanResponse: any, pendingId: number): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      const param = {
        pendingId: pendingId,
        vanResponse: vanResponse
      }
      var language = localStorage.getItem(Constants.Language);
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      header.append('Language', language || 'ko');
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_ServicePos_CancelSaleCardSuccess, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(param),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  cancelPrepaidSuccess(vanResponse: any, pendingId: number) {
    const param = {
      pendingId: pendingId,
      vanResponse: vanResponse
    }
    return this.http.post(UriApi.api_ServicePos_CancelPrepaidCardSuccess, param)
  }

  cancelPrepaidSuccessNoLoading(vanResponse: any, pendingId: number): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      const param = {
        pendingId: pendingId,
        vanResponse: vanResponse
      }
      var language = localStorage.getItem(Constants.Language);
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      header.append('Language', language || 'ko');
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_ServicePos_CancelPrepaidCardSuccess, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(param),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }
}
